import { createStructuredSelector } from "reselect";

import { getMessagesSelector, NotificationsState } from "../../ducks/notifications";

const structuredSelectors = createStructuredSelector<NotificationsState, NotificationsState>({
  messages: getMessagesSelector,
});

export default structuredSelectors;
